import { request as requestBase } from 'graphql-request';
import { useAuthStateStore } from '@annunciate/core';
export const request = async ({ query, endpoint, variables = {}, }) => {
    const token = useAuthStateStore.getState().token;
    return requestBase(`${endpoint}/graphql`, query, variables, {
        authorization: token ? `Bearer ${token}` : '',
    });
};
//# sourceMappingURL=request.js.map